import React from 'react';
import RealTransactionHybridCard from './RealTransactionHybridCard';
import AskPriceChartSection from './AskPriceChartSection';
import ListingVolumeChartSection from './ListingVolumeChartSection';
import './RealTransactionNewCard.css';

function RealTransactionNewCard({
  ptpOptions = [],
  weeklyRows = [],
  marketItems = [],
  targetPrice = null,
  familyCount = null,
  weeklyLoading = false,
  onWeeklyRangeChange,
  viewMode = 'sale',
  onViewModeChange,
  askPriceViewMode = 'sale',
  onAskPriceViewModeChange,
  marketLoading = false,
  ...cardProps
}) {
  return (
    <section className="tx-new-card-shell">
      <RealTransactionHybridCard {...cardProps} ptpOptions={ptpOptions} viewMode={viewMode} onViewModeChange={onViewModeChange} />
      <AskPriceChartSection
        marketItems={marketItems}
        targetPrice={targetPrice}
        viewMode={askPriceViewMode}
        onViewModeChange={onAskPriceViewModeChange}
        loading={marketLoading}
      />
      <ListingVolumeChartSection
        rows={weeklyRows}
        familyCount={familyCount}
        loading={weeklyLoading}
        onRequestRange={onWeeklyRangeChange}
      />
    </section>
  );
}

export default RealTransactionNewCard;
